export default {"src":"/_next/static/media/decision.ada750ba.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};